import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { TariffService } from '../services/tariff.service';
import { Commission } from '../tariff';
import { MatDialog } from '@angular/material';
import { DeleteDialogComponent } from '@app/driver-tariffs/delete-dialog/delete-dialog.component';

@Component({
  selector: 'app-commisson-bonuses',
  templateUrl: './commisson-bonuses.component.html',
  styleUrls: ['./commisson-bonuses.component.scss']
})
export class CommissonBonusesComponent implements OnInit, OnDestroy {
  commissionFormBonuses: FormGroup;
  private commissionFormArray: FormArray;
  private clearFormSubscription: Subscription;
  private isActiveCommission = false;
  isDisabledAddButton = false;
  private commissionData: Commission[];
  constructor(private fb: FormBuilder, private tariffService: TariffService, private dialog: MatDialog) {}

  ngOnInit() {
    this.commissionFormArray = this.fb.array([this.commissionControls()]);

    this.initForm();
    this.commissionFormBonuses.valueChanges.pipe(debounceTime(100)).subscribe(form => {
      this.tariffService.switchOverInputs(this.commissionFormArray);
      this.isFormValidTracker();
      this.tariffService.getCommissionTouche(!this.commissionFormArray.pristine);
    });

    this.clearFormSubscription = this.tariffService.clearFormEvent.subscribe((isClear: true) => {
      if (this.commissionData) {
        this.rebuildCommissionForm();
        this.initFormControlsValues(this.commissionData);
        this.disabledAddButton();
      } else {
        this.rebuildCommissionForm();
        this.disabledAddButton();
      }
    });
  }

  @Input('tariffCommission')
  set tariffCommission(tariffCommission: Commission[]) {
    if (tariffCommission) {
      this.rebuildCommissionForm();
      this.initFormControlsValues(tariffCommission);
      this.commissionData = tariffCommission;
      this.disabledAddButton();
    }
    if (!tariffCommission && this.commissionFormArray) {
      this.rebuildCommissionForm();
      this.commissionData = null;
    }
  }

  private initForm(): void {
    this.commissionFormBonuses = this.fb.group({
      commissions: this.commissionFormArray
    });
  }

  private initFormControlsValues(data: Commission[]) {
    this.rebuildCommissionForm(data);
    if (data.length > 1) {
      data.forEach((el: Commission, i) => {
        this.commissionFormArray && this.commissionFormArray.push(this.commissionControls(data[i++]));
      });
    } else {
      this.commissionFormArray && this.commissionFormArray.setControl(1, this.commissionControls(data ? data[0] : ''));
    }
  }

  private rebuildCommissionForm(data?) {
    if (this.commissionFormArray) {
      if (!data || (data && data.length <= 1)) {
        this.commissionFormArray &&
          this.commissionFormArray.setControl(1, this.commissionControls(data ? data[0] : ''));
      } else {
        this.commissionFormArray.removeAt(0);
      }
      this.commissionFormArray.getRawValue().forEach((el, i) => this.commissionFormArray.removeAt(i));
      if (this.commissionFormArray.getRawValue().length && data) {
        this.commissionFormArray.removeAt(0);
      }
      this.commissionFormArray.getRawValue().forEach((el, i) => this.commissionFormArray.removeAt(++i));
    }
  }

  private commissionControls(el?) {
    return this.fb.group({
      is_enabled: [el ? el.is_enabled : false],
      requests_quantity: [
        { value: el ? el.requests_quantity : 0, disabled: !this.isActiveCommission },
        Validators.compose([Validators.required, Validators.min(0), Validators.max(10000)])
      ],
      value: [
        { value: el ? el.value : 0, disabled: !this.isActiveCommission },
        Validators.compose([Validators.required, Validators.min(0), Validators.max(100)])
      ],
      id: [el ? el.id : '']
    });
  }

  private isFormValidTracker() {
    if (this.commissionFormArray.valid) {
      this.tariffService.getCommissionsArray(this.commissionFormArray.getRawValue());
    } else {
      this.tariffService.getCommissionsArray(null);
    }
  }

  addNewForm() {
    this.commissionFormArray.push(this.commissionControls());
    this.disabledAddButton();
  }
  private disabledAddButton() {
    if (this.commissionFormArray && this.commissionFormArray.getRawValue().length <= 10) {
      this.isDisabledAddButton = false;
    } else {
      this.isDisabledAddButton = true;
    }
  }

  onRemoveCommission(index: number) {
    const commissionId = this.commissionFormArray.getRawValue()[index].id;
    if (commissionId) {
      this.dialog
        .open(DeleteDialogComponent, {
          data: {
            message: 'COMMISSION_REMOVE_MSG'
          }
        })
        .afterClosed()
        .subscribe(res => {
          if (res) {
            this.removeCommissionInit(commissionId, index);
          }
        });
    } else {
      this.commissionFormArray.removeAt(index);
    }
  }

  private removeCommissionInit(commissionId: string, index: number) {
    this.tariffService.deleteTariffPlansCommission({ id: commissionId }).subscribe((isRemove: boolean) => {
      if (isRemove) {
        this.commissionFormArray.removeAt(index);
      }
      this.tariffService.loadTariffs();
    });
    this.disabledAddButton();
  }

  ngOnDestroy() {
    this.clearFormSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/driver-tariffs/commisson-bonuses/commisson-bonuses.component.ts